// Lets a funnel event fire at the step that starts the action, not at the click that opened the dialog.
export enum SettingsOpenOrigin {
  ConnectCalendarCard = 'connect-calendar-card',
}
